<template>
  <div>
    <Component :is="pageType" v-if="pageType !== ''" :pagedata="data?.data" />
    <LayoutBreadcrumb v-if="data?.data?.breadcrumbs?.length" :pagedata="data?.data" />
  </div>
  
</template>

<script setup lang="ts">
import type { Ref } from 'vue'
import { shouldLoadAdSenseScript } from '~/utils/shouldLoadAdSenseScript'

const pageTypes = [
  'ContentPageType',
  'ErrorPageType',
  'FaqPageType',
  'KontaktPageType',
  'LegalPageType',
  'ProductPageType',
  'RedirectPageType',
  'SearchPageType',
  'SitemapPageType',
  'PhotoCreditsPageType'
]

const route = useRoute()
const { $backend } = useNuxtApp()
const { data, error } = await $backend.pages.getPageByUrlPath(
  encodeURI(route.path),
  encodeURI(route.fullPath)
)

const { currentPortal } = usePortals()
const { links } = usePortalData()
const baseUrl = currentPortal.value?.portal.home.replace('http://', 'https://') ?? ''

if (route.path === '/') {
  useJsonLdWebsite().setWebsite(
    links?.portal_name ?? '',
    links?.portal_domain_name ?? '',
    baseUrl
  )
}

// const title: string = data.value?.data?.urldata?.title ?? ''
const pageTypeTemp: string = data.value?.data?.urldata?.pagetype ?? ''
const pageType: Ref<string> = ref(
  pageTypes.includes(pageTypeTemp) ? pageTypeTemp : ''
)

if (pageType.value === 'SearchPageType') {
  setPageLayout('search')
}

/*
useSeoMeta({
  title,
  ogTitle: title
  // TODO: Set data.value.data.pagedata.urldata.description field in the backend
  // description: data.value?.data?.pagedata?.urldata?.description ?? '',
  // ogDescription: data.value?.data?.pagedata?.urldata?.description ?? '',
  // ogImage: 'https://example.com/image.png',
  // twitterCard: 'summary_large_image',
})
*/

useHead(computed(() => data.value?.data?.urldata?.head))

const ADSENSE_SCRIPT_SRC = 'https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-6443769722344913'
useHead(() => {
  const pagetype = data.value?.data?.urldata?.pagetype ?? ''
  if (!shouldLoadAdSenseScript(pagetype, route.path, currentPortal.value?.portal?.portal)) {
    return {}
  }
  return {
    script: [
      {
        key: 'adsense',
        async: true,
        src: ADSENSE_SCRIPT_SRC,
        crossorigin: 'anonymous'
      }
    ]
  }
})

if (import.meta.server && error.value !== null) {
  // eslint-disable-next-line no-console
  console.error(error.value)
}
if (import.meta.server && pageTypeTemp && pageType.value === '') {
  // eslint-disable-next-line no-console
  console.error(`Error: ${pageTypeTemp} is not registered in [...slug].vue`)
}
</script>
